import palette from "../palette";
const MuiFormLabel = {
    styleOverrides: {
        root: {
            transform: 'translate(0px, -18px) scale(0.75) !important',
            fontSize: '14px',
            fontStyle: 'normal',
            fontWeight: 600,
            lineHeight: '20px',
            color: palette.common.fontColor
        },

    }
};

export default MuiFormLabel;
